<template>
  <div class="pset">
    <form @submit.prevent="save(true);" v-if="patient">
      <div class="cards" style="margin-bottom: 20px;">
        <div class="outside">
          <div class="wrapping">
            <div class="squares k">
              <label style="padding: 10px;">{{ $t('Name') }}:</label>
              <input type="text" class="room" name="quantity" style="width: 90%;" v-model="patient.name">
            </div>
            <div class="squares k">
              <label>{{ $t('Room') }}:</label>
              <input type="text" class="room" name="room" v-model="patient.room">
            </div>
            <div class="squares k">
              <label>{{ $t('Gender') }}:</label>
              <div>
                <select name="show" class="show" v-model="patient.gender">
                  <option value="f">{{ $t('female') }}</option>
                  <option value="m">{{ $t('male') }}</option>
                </select>
              </div>
            </div>
            <div class="squares d">
              <label>{{ $t('Weight') }}:</label>
              <div>
                <input type="text" v-model="patient.weight">
              </div>
            </div>

            <div class="squares k" style="font-weight: bold; grid-column: 1 / span 2; grid-row: 3;">
              <div class="bday">
                <label>{{ $t('date-of-birth') }}:</label>
                <datepicker v-model="patient.birth_date" :format="format"
                            style="color: black; box-shadow: none; width: 50%; position: relative; left: 25%;"
                            v-bind:placeholder="$t('select-date')" :language="datepickerLanguage"></datepicker>
                <div class="display">
                  {{ $t('Age') }}: {{ age }}
                </div>
              </div>
            </div>
            <div class="squares k" style="font-weight: bold; grid-column: 1 / span 2; grid-row: 4;">
              <span>{{$t('Connected Device')}}:</span>
              <span>
                  <v-select v-model="patient.devices_ids[0]" class="style-chooser"
                            style="background: white; border-radius: 10px; color: rgb(19,89,103);"
                            :reduce="device => device.id" label="name"
                            :options="this.$store.state.devices"></v-select>
              </span>
            </div>
          </div>
        </div>

        <div class="outside">
          <div class="wrapped">
            <div class="squares k">
              <div class="rs" style="text-align: center;">{{ $t('risk-status') }}:
                <select class="show" v-model="patient.risk">
                  <option v-for="option in riskOptions" v-bind:value="option.value">
                    {{ option.text }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="squares k" style="text-align: center;" v-if="patient.emergency_contacts">
            <div class="contact">
              <label>{{ $t('emergency-contacts') }}:</label><br><br>
              <div class="em" v-for="contact in patient.emergency_contacts">
                <span> {{ $t('Name') }}: <input type="text" id="fname" v-model="contact.name"></span>
                <span> {{ $t('Phone number') }}:<input type="tel" id="phone" v-model="contact.phone"></span>
              </div>
            </div>
          </div>
        </div>
        <div class="outside">
                    <span>{{ $t('medical-history') }}:
                        <textarea class="textb" v-model="patient.medical_history" rows="7"></textarea>
                    </span>
        </div>
        <div class="outside">
                    <span>{{ $t('Medications') }}:
                        <textarea class="textb" v-model="patient.medications" rows="7"></textarea>
                    </span>
        </div>
        <div class="outside">
                    <span>{{ $t('Allergies') }}:
                        <textarea class="textb" v-model="patient.allergies" rows="7"></textarea>
                    </span>
        </div>
        <div class="outside">
                    <span>{{ $t('recent-surgeries') }}:
                        <textarea class="textb" v-model="patient.recent_surgeries" rows="7"></textarea>
                    </span>
        </div>
        <div class="outside" style="grid-area: 5 / 1 / auto / span 2;">
                    <span>{{ $t('Comments') }}:
                        <textarea class="textb" v-model="patient.comments" rows="7"></textarea>
                    </span>
        </div>
      </div>
      <div class="text-center">
        <button @click.prevent="save(true)">
          {{ $t('Save and Close') }}
        </button>
        <button @click.prevent="save()">
          {{ $t('Save and Stay') }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import {en, ru} from 'vuejs-datepicker/dist/locale'
import axios from 'axios';
import {mapMutations, mapState} from 'vuex';
import moment from 'moment';
import i18n from '../plugins/i18n';

export default {
  name: 'PatientSettings',
  props: ['isNew'],
  data() {
    return {
      patient: {
        risk: 1,
        devices_ids: []
      },
      format: 'MMMM d yyyy',
      datepickerLangs: {
        en,
        ru
      },
      dt: new Date(),
      riskOptions: [
        {text: `1 (${this.$t('Low')})`, value: 1},
        {text: `2 (${this.$t('Medium')})`, value: 2},
        {text: `3 (${this.$t('High')})`, value: 3}
      ]
    }
  },
  methods: {
    save: async function (closeWindow = false) {
      try {
        let res
        if (this.patient.id) {
          res = await axios.put('/api/medical/patients/' + this.patient.id, this.patient).then(res => res.data);
        } else {
          res = await axios.post('/api/medical/patients', this.patient).then(res => res.data);
        }
        if (res.state === 'ok') {
          this.$notify({text: this.$t('Patient saved'), type: 'success'});
        } else {
          this.$notify({text: this.$t(res.message || 'Patient not saved'), type: 'warn'});
        }

        if (closeWindow) {
          this.hideModal();
        }
      } catch (err) {
        console.error(err);
        this.$notify({text: this.$t('Patient saving error'), type: 'error'});
      }
    },
    initComponent() {
      if (!this.isNew) {
        this.patient = this.$store.state.selectedPatient;
      } else {
        this.patient = {
          risk: 1,
          devices_ids: []
        }
      }
      this.$store.dispatch('loadDevices');
      this.prepareContacts();
      console.log('Patient', this.patient, this.isNew);
    },
    prepareContacts() {
      if (this.patient && !this.patient.emergency_contacts) {
        this.patient.emergency_contacts = [];
      }
      for (let i = 0; i < 3; i++) {
        if (!this.patient.emergency_contacts[i]) {
          this.patient.emergency_contacts.push({
            name: '',
            phone: ''
          });
        }
      }
    },
    ...mapMutations(['hideModal'])
  },
  computed: {
    age() {
      console.log(this.patient.birth_date);
      return this.patient.birth_date ? moment().diff(this.patient.birth_date, 'years') : ' - ';
    },
    datepickerLanguage() {
      return this.datepickerLangs[i18n.locale]
    },
    ...mapState(['selectedPatient'])
  },

  watch: {
    selectedPatient(newVal, oldVal) { // watch it
      console.log('patient changed: ', newVal, ' | was: ', oldVal)
      if (!this.isNew) {
        this.patient = newVal;
        this.prepareContacts();
      }
    },
    isNew(newVal, oldVal) { // watch it
      console.log('isNew changed: ', newVal, ' | was: ', oldVal)
      this.initComponent();
    }
  },

  mounted() {
    this.initComponent();
  },

  components: {
    Datepicker,
  }
}
</script>

<style>
.bday {
  text-align: center;
}

.weight {
  padding-bottom: 10px;
  text-align: center;
}

.room {
  padding: 10px;
  position: relative;
  text-align: center;
}

.textb {
  border-radius: 10px;
  padding-bottom: 10px;
  display: block;
  width: 97%;
  border-width: 2px;
  border-style: inset;
  border-color: initial;
  border-image: initial;
  margin-bottom: 10px;
}

#phone {
  border-radius: 10px;
  text-align: center;
  padding: 5px;
  box-shadow: none;
  width: 80%;
}

#quantity {
  border-radius: 10px;
  text-align: center;
  width: 40%;
  box-shadow: none;

}

.em {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 5px;
}

#fname {
  margin: 0;
  text-align: center;
  padding: 5px;
  border-width: 2px;
  border-style: inset;
  border-color: initial;
  border-image: initial;
  box-shadow: none;
  width: 90%;
}

.cont input {
  width: 100%;
  clear: both;
}

.room {
  padding: 5px;
  border-width: 2px;
  border-style: inset;
  border-color: initial;
  border-image: initial;
  border-radius: 10px;
  box-shadow: none;
}

.squares {
  background: none;
  color: white;
  border-radius: 2px;
  padding: 10px;
  font-family: "Chivo", sans-serif;
  font-size: 1.2vw;
  position: relative;
  margin-bottom: 1px;
  box-shadow: 0 0 3px 0px #ddd;
  text-align: center;
  vertical-align: bottom;
}

.wrapping {
  display: grid;
  grid-template-columns: repeat(2, minmax(10%, 2fr) );
  color: wheat;
  border-radius: 5px;
  position: relative;
}

.wrapped {
  display: grid;
  grid-template-columns: repeat(1, minmax(10%, 2fr) );
  color: wheat;
  border-radius: 5px;
}

.outside {
  background: none;
  border-width: 2px;
  padding: 0px;
  padding-top: 10px;
  size: 100px;
  margin: 10px;
  border-radius: 5px;
  padding: 10px;
  box-shadow: 0px 0px 10px #0ff;
}

.cards {
  flex-direction: row;
  flex-wrap: wrap;
  /* left: 1vw; */
  position: relative;
  margin-bottom: 20px;
  display: grid;
  grid-gap: 7px;
  grid-template-columns: repeat(2, minmax(10%, 2fr) );
  width: 100%;
}

.one-row-input {
  display: flex;
  justify-content: center;
  align-items: center;
}
.one-row-input > label {
  display: block;
  width: 30%;
}
.one-row-input > *:last-child {
  width: 70%;
}
</style>
<style scoped>
form {
  width: 100%;
  font-size: 1.2vw;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/PatientSettings.vue